import "./index.css";

import { createBrowserRouter, RouterProvider } from "react-router";
import { NotFound } from "@repo/ui";
import { AuthGuard } from "@repo/auth";
import { Home } from "./routes/home";

const router = createBrowserRouter([
  // Route candidat — authentification légère (nom de famille uniquement)
  {
    path: "/e/:id",
    element: <AuthGuard />,
    children: [
      {
        index: true,
        element: <Home />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}

export default App;
